import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export const StickyBar: React.FC = () => {
  const {
    minutes,
    seconds
  } = useCountdown();
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-2 px-4 shadow-md" data-id="element-272">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-273">
        <p className="font-bold text-sm sm:text-base text-center" data-id="element-274">
          ⚠️ ATENCIÓN: Esta oferta especial de lanzamiento expira pronto
        </p>
        <div className="flex items-center gap-1 font-mono bg-black/20 px-3 py-1 rounded-md font-bold" data-id="element-275">
          <span data-id="element-276">00</span>:<span data-id="element-277">{minutes}</span>:<span data-id="element-278">{seconds}</span>
        </div>
      </div>
    </div>;
};